import {
  customer_api,
  loan_application_api,
} from '@axo/shared/data-access/api';
import { customer } from '@axo/shared/data-access/types';
import { Handler } from '../api-orchestrator';
import { IPreconditions } from '../types/IPreconditions';

// Note: MarketingConsent creation is done in the marketingConsentHandler to separate conserns

interface Dependencies {
  postCustomer: typeof customer_api.postCustomer;
  patchCustomer: typeof customer_api.patchCustomer;
  patchLoanApplication: typeof loan_application_api.patchLoanApplication;
}

export const customerHandlerFactory =
  ({
    postCustomer,
    patchCustomer,
    patchLoanApplication,
  }: Dependencies): Handler<customer.CreateCustomer, IPreconditions> =>
  async ({
    data,
    preconditions: {
      customerId,
      customerJWT,
      loanApplicationId,
      customerEmail,
    },
    baseUrl,
  }) => {
    if (!data.Email || !data.MobilePhoneNumber) return { didSync: false };

    // Remove non-numeric characters from phone number
    data.MobilePhoneNumber = data.MobilePhoneNumber.replaceAll(/\D/g, '');

    const emailChanged = customerEmail && customerEmail !== data.Email;
    const customerExists = !!customerId;

    if (customerExists && !emailChanged && customerJWT) {
      const api = { url: { service: baseUrl }, token: customerJWT };
      await patchCustomer(api)(customerId, data);
      return {
        didSync: true,
      };
    }

    const customer = await postCustomer(baseUrl, data);
    let patched;

    // postCustomer does only save email, patching data must happen afterwards
    if (customer.JWT && customer.ID) {
      const api = { url: { service: baseUrl }, token: customer.JWT };
      patched = await patchCustomer(api)(customer.ID, data);
    }

    if (loanApplicationId && customerJWT) {
      const api = { url: { service: baseUrl }, token: customerJWT };
      await patchLoanApplication(api)(loanApplicationId, {
        CustomerID: customer.ID,
      });
    }

    return {
      didSync: true,
      newPreconditions: {
        customerId: customer.ID,
        customerJWT: customer.JWT,
        customerEmail: customer.Email,
        customerMobilePhoneCountryCode: patched?.MobilePhoneCountryCode,
        customerMobilePhoneNumber: patched?.MobilePhoneNumber,
      },
    };
  };
